<!-- Questionnaire -->

<div class="m-t-20 m-b-60">

  <nz-table class="table-quest" [nzData]=[1,2,3] [nzScroll]="{ x:'1200px',y: '460px' }">
    <thead>
      <tr>
        <th class="main" nzLeft="0px" nzWidth="300px">Question</th>
        <th *ngFor="let clientDO of insuredClientList">
          <div class="quest-person">
            <div class="f-l m-r-10 m-t-5">
              <nz-avatar style="color:#FFF; background-color:#329ffd;" nzSize="small" nzIcon="anticon anticon-user">
              </nz-avatar>
            </div>
            <strong>{{clientDO | MMSClientData: 'fullName'}}</strong>
            <span> DOB: {{(clientDO | MMSClientData: 'dateOfBirth') | date}}</span>
          </div>
        </th>
        <!-- <th>
            <div class="quest-person">
              <div class="f-l m-r-10 m-t-5">
                <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
              </div>
              <strong>Insured</strong>
              <span>Ms. Rachel Hemsworth</span>
            </div>
          </th>
          <th>
            <div class="quest-person">
              <div class="f-l m-r-10 m-t-5">
                <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
              </div>
              <strong>Insured</strong>
              <span>Mr. Liam Hemsworth</span>
            </div>
          </th>
          <th>
            <div class="quest-person">
              <div class="f-l m-r-10 m-t-5">
                <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
              </div>
              <strong>Insured</strong>
              <span>Mr. Luke Hemsworth</span>
            </div>
          </th>
          <th>
            <div class="quest-person">
              <div class="f-l m-r-10 m-t-5">
                <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
              </div>
              <strong>Insured</strong>
              <span>Mr. Roger Hemsworth</span>
            </div>
          </th> -->
      </tr>
    </thead>

    <tbody>

      <ng-container>
        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">1. Do you have Hypertension History?</td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="Hypertension" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="Hypertension" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">1 a. Duration </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input *ngIf="i%2" nz-input placeholder="in years" class="quest-input-width" />
            <ng-container *ngIf="!(i%2)">N/A</ng-container>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">1 b. Medication </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input *ngIf="i%2" nz-input placeholder="" class="quest-input-width" />
            <ng-container *ngIf="!(i%2)">N/A</ng-container>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">1 c. Dosage </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input *ngIf="i%2" nz-input placeholder="" class="quest-input-width" />
            <ng-container *ngIf="!(i%2)">N/A</ng-container>
          </td>
        </tr>

        <!-- -------------------------------------------- -->

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">2. Do you have Diabetes Mellitus History?</td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="Diabetes" [ngModel]="!(i%2)">Yes</label>
            <label nz-checkbox nzValue="A" name="Diabetes" [ngModel]="i%2">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">2 a. Type 1 or Type 2 Diabetes? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <ng-container *ngIf="!(i%2)">
              <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">Type 1</label>
              <label nz-checkbox nzValue="A" name="DiabetesType">Type 2</label>
              <!-- <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">N/A</label> -->
            </ng-container>


            <ng-container *ngIf="i%2">N/A</ng-container>

          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">2 b. Duration </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input *ngIf="!(i%2)" nz-input placeholder="in years" class="quest-input-width" />
            <ng-container *ngIf="i%2">N/A</ng-container>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">2 c. Medications </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input *ngIf="!(i%2)" nz-input placeholder="" class="quest-input-width" />
            <ng-container *ngIf="i%2">N/A</ng-container>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">2 d. Dosage </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input *ngIf="!(i%2)" nz-input placeholder="" class="quest-input-width" />
            <ng-container *ngIf="i%2">N/A</ng-container>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">3. Heart and Circulatory Conditions/Disorders: chest pain,
            angina, high cholesterol/lipids, palpitations, congestive heart failure, coronary artery disease,heart
            attack, bypass surgery/angioplasty, valve disorder/replacement, pacemaker insertion, rheumatic fever,
            congenital heart condition, varicose veins,
            thrombosis, blood disorders etc.? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>


        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">4. Urinary Conditions/Disorders: Blood in urine, urinary
            frequency, painful/difficult urination Kidney and/or Bladder infections, stones of urinary system, renal
            failure, dialysis or Any Other Kidney/Urinary Tract Or Prostate Disease? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">5. Musculoskeletal Conditions/Disorders: Joint/back pain
            Arthritis, Spondylosis, Joint Replacement Or Any Other Disorder of Muscle/ Bone/ Joint/ ligaments, tendons
            or discs, gout, herniated disc, amputation/prosthesis? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">6. Respiratory Conditions/Disorders: Shortness/difficulty of
            breath, Tuberculosis, Asthma, Bronchitis, Chronic Obstructive Pulmonary Disease COPD, chronic cough ,
            coughing of blood, etc or any Other Lung / Respiratory Disease? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">7. Digestive Conditions/Disorders: Jaundice, chronic diarrhea,
            intestinal bleeding/problems/polyps, diseases of the pancreas, liver or gall bladder, hepatitis A/B/C/other,
            jaundice, Cirrhosis, unexplained weight loss or gain, eating disorder or any Other Gastro Intestinal
            condition? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">8. Cancer/Tumor - Benign Or Malignant tumor, Any Growth/Cyst,
            any
            Cancer? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">9. Brain/Nervous System/ Psychiatric Conditions/Disorders: Loss
            of consciousness, fainting, dizziness, numbness/tingling, weakness, paralysis, head injury, stroke, migraine
            headaches or chronic severe headaches, sleep apnea, multiple sclerosis, seizures/epilepsy or any Other
            Brain/ Nervous System Disease, Mental/Psychiatric disorder? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">10. Female Reproductive Conditions/Disorders: Pelvic pain,
            abnormal, menstrual bleeding abnormal PAP smear, endometriosis, Fibroid, Cyst/ Fibroadenoma, Bleeding
            Disorder, Pelvic infection Or Any Other Gynecological / Breast cysts/lumps/tumor? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">11. Is any female member pregnant, tested positive with a home
            pregnancy test, or in the process of adoption or becoming a surrogate? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">12. Metabolic and Endocrine Conditions/Disorders:
            Adrenal/pituitary disorders, thyroid disorder, lupus, scleroderma, thyroid disorders, any autoimmune/genetic
            disorder? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">13. Does the person proposed to be insured suffer from any
            chronic or long-term medical condition, or have any other disability, abnormality or recurrent illness or
            injury or unable to perform normal activities? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">14. Does the person proposed to be insured use tobacco
            products/cigarettes or drinks alcohol? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">15. Has any member consulted with or received treatment from any
            doctor or other health care provider for any other condition or symptom(s)/undergone any
            hospitalization/illness/surgery/ currently taking medication(s) for any condition or medical procedures
            (including diagnostic testing)? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">16. Have you or any of the persons proposed for Insurance been
            diagnosed with or undergone surgery for any of the following Critical Illnesses, prior to proposing for this
            cover - Cancer, Heart Attack, Coronory Artery, Bypass Graft, Heart Valve Replacement/ Repair, Coma, Kidney
            Failure, Stroke, any Transplant, Paralysis, Multiple Sclerosis, Motor Neurone Disease? </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="i%2">Yes</label>
            <label nz-checkbox nzValue="A" name="DiabetesType" [ngModel]="!(i%2)">No</label>
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">17. What is your height?(cms) </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input nz-input placeholder="in cms" class="quest-input-width" />
          </td>
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">18. What is your weight?(kgs) </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input nz-input placeholder="in kgs" class="quest-input-width" />
          </td>
        </tr>
      </ng-container>




      <ng-container *ngIf="false">
        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">1. Do you smoke?</td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" name="isSmoker" [ngModel]="i%2">Yes</label>
          </td>
          <!-- <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td> -->
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">2. What is your height?(cms) </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <input nz-input placeholder="in cms" class="quest-input-width" />
          </td>
          <!-- <td>
            <input nz-input placeholder="in cms" class="quest-input-width" />
          </td>
          <td>
            <input nz-input placeholder="in cms" class="quest-input-width" />
          </td>
          <td>
            <input nz-input placeholder="in cms" class="quest-input-width" />
          </td>
          <td>
            <input nz-input placeholder="in cms" class="quest-input-width" />
          </td> -->
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">3. Have you ever had child-birth related disorders? </td>
          <ng-container *ngFor="let client of insuredClientList; let i=index">

            <td *ngIf="i%2">
              <span class="disabled">N/A</span>
            </td>
            <td *ngIf="!(i%2)">
              <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
              <nz-select nzShowSearch class="quest-input-width d-b" nzAllowClear nzPlaceHolder="Choose" ngModel="pre">
                <nz-option nzValue="eco" nzLabel="Ectopic"></nz-option>
                <nz-option nzValue="pre" nzLabel="Pre-term labor"></nz-option>
              </nz-select>
            </td>
          </ng-container>
          <!-- <td>
            <span class="disabled">N/A</span>
          </td>
          <td>
            <span class="disabled">N/A</span>
          </td>
          <td>
            <span class="disabled">N/A</span>
          </td> -->
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">4. Have you ever had any of the following conditions?</td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <!-- Leave blank -->
          </td>
          <!-- <td>
          </td>
          <td>
          </td>
          <td>
          </td>
          <td>
          </td> -->
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 a. Stroke, transient ischaemic attack (TIA), brain haemorrhage, brain aneurysm or other brain related
            injuries?
          </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <!-- <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td> -->
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 b. Chest Pain, Angio, heart attack, heart enlargement, heart failure or any other heart conditon?
          </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
            <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b" />
          </td>
          <!-- <td>
            <label nz-checkbox nzValue="A" name="heart1" [ngModel]="true">Yes</label>
            <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b" value="Chest Pain" />
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
            <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b" />
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
            <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b" />
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
            <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b" />
          </td> -->
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 c. Peripheral vascular or any disease or disorder of the aorta or arteries?
          </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <!-- <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td> -->
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="sub">
            4 d. Asthama, bronchitis, pneumonia, tuberculosis, emphysems or any other breating / lung disorder?
          </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <!-- <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td> -->
        </tr>

        <tr>
          <td nzLeft="0px" nzWidth="300px" class="main">
            5. Are you currently serving in the Armed Forces, or planning to in the future?
          </td>
          <td *ngFor="let client of insuredClientList; let i=index">
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <!-- <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="false">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td>
          <td>
            <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
          </td> -->
        </tr>
      </ng-container>


    </tbody>

  </nz-table>

</div>
